module.exports = __webpack_public_path__ + "media/fonts/slick-29518378.woff";